import React, { useState } from 'react';
import { api } from '../lib/api';
import toast from 'react-hot-toast';  // [PATCH partner-sifra-unikat v1] napaka ne sme biti pozrta

/**
 * Prikaz Vasco/programske šifre partnerja v glavi dokumenta.
 * - Če partner ima vasco_code -> prikaže #šifro (klik = uredi).
 * - Če je nima -> klikabilen badge "Ni šifre" -> inline vnos -> PUT posodobi partnerja.
 * Po uspehu pokliče onSaved(code), da nadrejeni lokalno posodobi selected.partner.
 */
export function VascoSifraBadge({ companyId, partner, izvozProgram, onSaved }: {
  companyId: string;
  partner: any;
  izvozProgram?: string;
  onSaved: (vasco_code: string) => void;
}) {
  const [urejanje, setUrejanje] = useState(false);
  const [vrednost, setVrednost] = useState('');
  const [shranjevanje, setShranjevanje] = useState(false);

  const oznaka = (izvozProgram || 'vasco') === 'vasco' ? 'Vasco šifra' : 'Šifra';

  if (!partner?.id) {
    // Brez vezanega partnerja ni kam shraniti šifre
    return (
      <span className="bg-red-100 dark:bg-red-950 px-1.5 py-0.5 rounded text-xs font-mono text-red-500">Ni šifre</span>
    );
  }

  const shrani = async () => {
    const _v = vrednost.trim();
    if (!_v) { setUrejanje(false); return; }
    setShranjevanje(true);
    try {
      await api.put(`/sifranti/partnerji/${companyId}/${partner.id}`, { vasco_code: _v });
      onSaved(_v);
      setUrejanje(false);
      setVrednost('');
    } catch (e: any) {
      // [PATCH partner-sifra-unikat v1] prej je bila napaka pozrta - 409 o zasedeni sifri ni bil viden
      toast.error(e?.response?.data?.detail || 'Šifre ni bilo mogoče shraniti.');
      // ob napaki ostani v urejanju
    } finally {
      setShranjevanje(false);
    }
  };

  if (urejanje) {
    return (
      <span className="inline-flex items-center gap-1">
        <input autoFocus value={vrednost} onChange={e => setVrednost(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') shrani(); if (e.key === 'Escape') { setUrejanje(false); setVrednost(''); } }}
          disabled={shranjevanje}
          className="w-24 px-1.5 py-0.5 bg-white dark:bg-gray-800 border border-blue-400 rounded text-xs font-mono text-gray-900 dark:text-white outline-none"
          placeholder={oznaka} />
        <button onClick={shrani} disabled={shranjevanje}
          className="text-xs text-blue-600 dark:text-blue-400 hover:underline disabled:opacity-50">
          {shranjevanje ? '...' : 'Shrani'}
        </button>
      </span>
    );
  }

  if (partner?.vasco_code) {
    // [PATCH sifra-znacka-samo-brez v1] sifra, ki obstaja, se tu NE ureja (polje je vabilo k zmedi z iskalnikom);
    // sprememba sifre obstojecemu partnerju = sifrant (svincnik ob nazivu).
    return (
      <span title={oznaka + ' partnerja — spremembo naredi v šifrantu (svinčnik)'}
        className="bg-gray-100 dark:bg-gray-700 px-1.5 py-0.5 rounded text-xs font-mono text-gray-500">
        #{partner.vasco_code}
      </span>
    );
  }

  return (
    <button onClick={() => { setVrednost(''); setUrejanje(true); }}
      title={'Klikni za vnos (' + oznaka + ')'}
      className="bg-red-100 dark:bg-red-950 px-1.5 py-0.5 rounded text-xs font-mono text-red-500 hover:ring-1 hover:ring-red-400 transition">
      Ni šifre
    </button>
  );
}
